module.exports = __webpack_public_path__ + "static/media/login.628bc2ac.png";